// extracted by mini-css-extract-plugin
export default {"errors":"errors_block_errors__yCORK","errors__text":"errors_block_errors__text__m-RnW"};